<template>
    <div class="brands-text" v-if="brands">
        <div class="brands">
            <div class="brands-inner">
                <p v-if="brands['title']"><strong>{{ brands['title'] }}</strong></p>

                <div class="brand-wrapper">
                    <div v-for="(group) in isGroupAmount()" :key="`group-${group}`" :class="[`group-brand-${group}`]" class="labels">
                        <p v-for="(item, index) in filterBrandsByGroup(group)" v-bind:key="index" class="brand-text" :class="[`label-text-${index + 1}`]">
                            {{ item['label'] }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Brands',

        props: {
            brands: {
                type: Object,
            },
        },

        methods: {
            filterBrandsByGroup(group) {
                return this.brands['items'].filter(brand => brand.group ? brand.group === group : true);
            },
            isGroupAmount() {
                let group = 1;
                this.brands['items'].forEach(brand => {
                    if (brand.group) {   
                        group = brand.group > group ? brand.group : group;
                    }
                });

                return group;
            }
        }
    }
</script>

<style scoped lang="scss">
  @import "@/assets/scss/components/layout/banners/brandsText";
</style>
